export const translations = {
  pt: {
    nav: {
      quemSomos: 'Quem Somos',
      produtos: 'Produtos',
      contato: 'Contato',
    },
    sections: {
      slogan: 'Slogan',
      quemSomos: 'Quem Somos',
      proposito: 'Propósito',
      produtos: 'Produtos',
      contato: 'Contato',
    },
    slogan: {
      title: 'Eficiência que transforma',
      logoAlt: 'Logo Wee Time - Empresa de desenvolvimento de software',
    },
    quemSomos: {
      title: 'Quem Somos',
      paragraphs: [
        'Durante 15 anos, estivemos dentro de empresas de diferentes segmentos, vivenciando de perto os desafios reais da operação \u2014 o tempo desperdiçado, o retrabalho, a falta de organização e os custos que poderiam ser evitados.',
        'Nesse período, desenvolvemos soluções práticas que fizeram diferença real: dispositivos que aumentaram a atenção dos operadores, sistemas kanban que deram previsibilidade às equipes, planilhas que organizaram fluxos de trabalho e controles de processo que garantiram qualidade e confiabilidade.',
        'Observamos também as demandas da vida moderna \u2014 pessoas de diferentes culturas, rotinas cada vez mais aceleradas e a constante necessidade de ferramentas que devolvam tempo e simplicidade ao dia a dia.',
        'Em 2023, levamos essa experiência para uma aceleração de startups. Entre 35 candidatos, nos formamos entre os 14 selecionados \u2014 validando nossa capacidade de identificar problemas reais e construir soluções com potencial de mercado.',
        'Foi dessa jornada que nasceu a Wee Time \u2014 para transformar com tecnologia tudo o que aprendemos na prática.',
      ],
    },
    proposito: {
      title: 'Propósito',
      content: 'Criamos soluções práticas que otimizam o recurso mais precioso: seu tempo.\nAcreditamos que, usado com eficiência, ele revoluciona como você trabalha e vive.\nNossas ferramentas impulsionam essa transformação \u2013 comece agora.',
    },
    produtos: {
      title: 'Produtos',
      subtitle: 'Oferecemos soluções que poupam tempo e tornam sua rotina mais eficiente.',
      comingSoon: 'Em breve, nossa solução será lançada. Acompanhe-nos para conhecê-la em primeira mão.',
    },
    contato: {
      title: 'Contato',
      content: 'Fale com a gente. Acesse nossa área de suporte, envie seu feedback ou tire suas dúvidas.',
    },
    footer: {
      quemSomos: 'Quem Somos',
      produtos: 'Produtos',
      contato: 'Contato',
      privacidade: 'Privacidade',
      cookiePrefs: 'Preferências de Cookies',
      language: 'Idioma',
      portugues: 'Português',
      ingles: 'Inglês',
    },
    privacy: {
      title: 'Privacidade',
      subtitle: 'Sua privacidade é prioridade. Tratamos suas informações com segurança, transparência e responsabilidade.',
      policyLink: 'Política de privacidade',
      termsLink: 'Termos de Uso',
      unsolicitedLink: 'Política de Envio de Ideias Não Solicitadas',
      refundLink: 'Política de Reembolso',
      cookiePolicyLink: 'Política de Cookies',
      preferencesLink: 'Gerenciar preferências',
    },
    cookies: {
      bannerText: 'Usamos cookies essenciais para o funcionamento do site. Cookies de analytics (Google Analytics) só são ativados com sua autorização. O site não exibe publicidade.\n\nSaiba mais na',
      policyLink: 'Política de Privacidade',
      acceptAll: 'Aceitar Todos',
      rejectAll: 'Recusar Todos',
      manage: 'Gerenciar',
      preferencesTitle: 'Gerenciar Preferências de Cookies',
      essential: 'Cookies Essenciais',
      essentialDesc: 'Necessários para o funcionamento básico do site. Não podem ser desativados.',
      analytics: 'Cookies de Analytics',
      analyticsDesc: 'Google Analytics — ajudam a entender como o site é utilizado, de forma agregada. Desativados por padrão.',
      save: 'Salvar Preferências',
    },
    contactPage: {
      title: 'Contato',
      subtitle: 'Use o formulário abaixo para solicitar a informações que precisa.',
      topicPlaceholder: 'Gostaria de falar sobre',
      topicSupport: 'Dúvidas ou suporte técnico',
      topicFeedback: 'Comentários ou sugestões',
      topicData: 'Contas e Dados',
      topicPrivacy: 'Privacidade e consentimento',
      requiredFields: 'Os campos são de preenchimento obrigatório.',
      namePlaceholder: 'Nome',
      emailPlaceholder: 'Endereço de e-mail',
      subjectPlaceholder: 'Assunto',
      commentsPlaceholder: 'Comentários',
      nameError: 'Insira seu nome.',
      emailError: 'Insira um e-mail válido ou alternativo.',
      subjectError: 'Insira um assunto.',
      commentsError: 'Insira um comentário.',
      policyPrefix: 'Para prosseguir com o envio da tua solicitação, leia a ',
      policyLinkText: 'Política de Envio Não Solicitado de Ideias',
      policySuffix: '.',
      submitButton: 'Enviar',
      submitting: 'Enviando...',
      successTitle: 'Sucesso',
      successDefault: 'Mensagem enviada com sucesso! Recebemos seu contato sobre {topic} e responderemos em breve para o e-mail informado.',
      successFeedback: 'Muito obrigado por compartilhar seus comentários e sugestões conosco. Valorizamos muito esse tipo de contribuição — ela é essencial para o nosso aprendizado e melhoria contínua.\n\nLemos tudo com atenção, mas não conseguimos responder individualmente a todas as mensagens. Ainda assim, saiba que sua mensagem foi considerada com cuidado e certamente contribui para nosso crescimento.\n\nAgradecemos novamente pelo seu tempo e confiança!',
      errorTitle: 'Erro',
      errorRetry: 'Ops! Ocorreu um erro ao enviar sua mensagem. Por favor, tente novamente.',
      errorFinal: 'Vejo que há uma instabilidade no sistema, entre em contato diretamente pelo e-mail',
      phoneBanner: 'Fale com nosso Atendimento ao Cliente',
    },
  },
  en: {
    nav: {
      quemSomos: 'About Us',
      produtos: 'Products',
      contato: 'Contact',
    },
    sections: {
      slogan: 'Slogan',
      quemSomos: 'About Us',
      proposito: 'Purpose',
      produtos: 'Products',
      contato: 'Contact',
    },
    slogan: {
      title: 'Efficiency that sets you free',
      logoAlt: 'Wee Time Logo - Software development company',
    },
    quemSomos: {
      title: 'About Us',
      paragraphs: [
        'For 15 years, we were inside companies across different industries, experiencing firsthand the real challenges of daily operations \u2014 wasted time, rework, lack of organization, and costs that could have been avoided.',
        'During that period, we developed practical solutions that made a real difference: devices that increased operator attention, kanban systems that brought predictability to teams, spreadsheets that organized workflows, and process controls that ensured quality and reliability.',
        'We also observed the demands of modern life \u2014 people from different cultures, increasingly fast-paced routines, and the constant need for tools that give back time and simplicity to everyday life.',
        'In 2023, we brought that experience to a startup acceleration program. Among 35 candidates, we graduated among the selected 14 \u2014 validating our ability to identify real problems and build solutions with market potential.',
        'It was from that journey that Wee Time was born \u2014 to transform with technology everything we learned in practice.',
      ],
    },
    proposito: {
      title: 'Purpose',
      content: 'We create practical solutions that make the best use of your most valuable resource: your time.\nWe believe that, when used efficiently, it transforms the way you work and live.\nOur tools drive that transformation - Start now',
    },
    produtos: {
      title: 'Products',
      subtitle: 'We offer solutions that save time and make your routine more efficient.',
      comingSoon: 'Coming soon, our solution will be launched. Follow us to be among the first to discover it.',
    },
    contato: {
      title: 'Contact',
      content: 'Talk to us. Access our support area, send us your feedback, or ask any questions you may have.',
    },
    footer: {
      quemSomos: 'About Us',
      produtos: 'Products',
      contato: 'Contact',
      privacidade: 'Privacy',
      cookiePrefs: 'Cookie Preferences',
      language: 'Language',
      portugues: 'Portuguese',
      ingles: 'English',
    },
    privacy: {
      title: 'Privacy',
      subtitle: 'Your privacy is our priority. We handle your information with security, transparency, and responsibility.',
      policyLink: 'Privacy Policy',
      termsLink: 'Terms of Use',
      unsolicitedLink: 'Unsolicited Idea Submission Policy',
      refundLink: 'Refund Policy',
      cookiePolicyLink: 'Cookie Policy',
      preferencesLink: 'Manage Preferences',
    },
    cookies: {
      bannerText: 'We use essential cookies for the site to function. Analytics cookies (Google Analytics) are only activated with your authorization. This site does not display advertising.\n\nLearn more in our',
      policyLink: 'Privacy Policy',
      acceptAll: 'Accept All',
      rejectAll: 'Reject All',
      manage: 'Manage',
      preferencesTitle: 'Manage Cookie Preferences',
      essential: 'Essential Cookies',
      essentialDesc: 'Required for the basic functioning of the site. Cannot be disabled.',
      analytics: 'Analytics Cookies',
      analyticsDesc: 'Google Analytics — help us understand how the site is used, in aggregate form. Disabled by default.',
      save: 'Save Preferences',
    },
    contactPage: {
      title: 'Contact',
      subtitle: 'Use the form below to request the information you need.',
      topicPlaceholder: 'I would like to talk about',
      topicSupport: 'Questions or technical support',
      topicFeedback: 'Comments or suggestions',
      topicData: 'Accounts and Data',
      topicPrivacy: 'Privacy and consent',
      requiredFields: 'All fields are required.',
      namePlaceholder: 'Name',
      emailPlaceholder: 'Email address',
      subjectPlaceholder: 'Subject',
      commentsPlaceholder: 'Comments',
      nameError: 'Please enter your name.',
      emailError: 'Please enter a valid or alternative email.',
      subjectError: 'Please enter a subject.',
      commentsError: 'Please enter a comment.',
      policyPrefix: 'To proceed with sending your request, please read the ',
      policyLinkText: 'Unsolicited Idea Submission Policy',
      policySuffix: '.',
      submitButton: 'Send',
      submitting: 'Sending...',
      successTitle: 'Success',
      successDefault: 'Message sent successfully! We have received your contact about {topic} and will respond shortly to the email provided.',
      successFeedback: 'Thank you very much for sharing your comments and suggestions with us. We greatly value this kind of contribution \u2014 it is essential for our learning and continuous improvement.\n\nWe read everything carefully, but we are unable to respond individually to every message. Nonetheless, please know that your message was considered with care and certainly contributes to our growth.\n\nThank you again for your time and trust!',
      errorTitle: 'Error',
      errorRetry: 'Oops! An error occurred while sending your message. Please try again.',
      errorFinal: 'It seems there is a system instability. Please contact us directly at',
      phoneBanner: 'Talk to our Customer Service',
    },
  },
};
